function openMyimage(srcimage){
var modal = document.getElementById("myModalIF");
var span = document.getElementsByClassName("closeIF")[0];
modal.style.display = "block";
document.getElementById("contentimg").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}

function openMyimageSofisticata(srcimage){
var modal = document.getElementById("myModalIFSofisticata");
var span = document.getElementById("closeSofisticata");
modal.style.display = "block";
document.getElementById("contentimgSofisticata").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}

function openMyimageIdeale(srcimage){
var modal = document.getElementById("myModalIFIdeale");
var span = document.getElementById("closeIdeale");
modal.style.display = "block";
document.getElementById("contentimgIdeale").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}

function openMyimageSemplice(srcimage){
var modal = document.getElementById("myModalIFSemplice");
var span = document.getElementById("closeSemplice");
modal.style.display = "block";
document.getElementById("contentimgSemplice").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}

function openMyimageElementare(srcimage){
var modal = document.getElementById("myModalIFElementare");
var span = document.getElementById("closeElementare");
modal.style.display = "block";
document.getElementById("contentimgElementare").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}

function openMyimageMC(srcimage){
var modal = document.getElementById("myModalIFMC");
var span = document.getElementById("closeMC");
modal.style.display = "block";
document.getElementById("contentimgMC").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}

function openMyimageMCSofisticata(srcimage){
var modal = document.getElementById("myModalIFMCSofisticata");
var span = document.getElementById("closeMCSofisticata");
modal.style.display = "block";
document.getElementById("contentimgmcSofisticata").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}

function openMyimageMCIdeale(srcimage){
var modal = document.getElementById("myModalIFMCIdeale");
var span = document.getElementById("closeMCIdeale");
modal.style.display = "block";
document.getElementById("contentimgmcIdeale").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}

function openMyimageMCSemplice(srcimage){
var modal = document.getElementById("myModalIFMCSemplice");
var span = document.getElementById("closeMCSemplice");
modal.style.display = "block";
document.getElementById("contentimgmcSemplice").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}

function openMyimageMCElementare(srcimage){
var modal = document.getElementById("myModalIFMCElementare");
var span = document.getElementById("closeMCElementare");
modal.style.display = "block";
document.getElementById("contentimgMCElementare").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}


function openMyimageCC(srcimage){
var modal = document.getElementById("myModalIFCC");
var span = document.getElementById("closeCC");
modal.style.display = "block";
document.getElementById("contentimgCC").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}

function openMyimageCCSofisticata(srcimage){
var modal = document.getElementById("myModalIFCCSofisticata");
var span = document.getElementById("closeCCSofisticata");
modal.style.display = "block";
document.getElementById("contentimgccSofisticata").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}

function openMyimageCCIdeale(srcimage){
var modal = document.getElementById("myModalIFCCIdeale");
var span = document.getElementById("closeCCIdeale");
modal.style.display = "block";
document.getElementById("contentimgccIdeale").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}

function openMyimageCCSemplice(srcimage){
var modal = document.getElementById("myModalIFCCSemplice");
var span = document.getElementById("closeCCSemplice");
modal.style.display = "block";
document.getElementById("contentimgccSemplice").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}

function openMyimageCCElementare(srcimage){
var modal = document.getElementById("myModalIFCCElementare");
var span = document.getElementById("closeCCElementare");
modal.style.display = "block";
document.getElementById("contentimgccElementare").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}

function openMyimageFF(srcimage){
var modal = document.getElementById("myModalIFFF");
var span = document.getElementById("closeFF");
modal.style.display = "block";
document.getElementById("contentimgFF").src = srcimage;
span.onclick = function() {
  	modal.style.display = "none";
}
}
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  var modal = document.getElementById("myModalIF");
  if (event.target == modal) {
    modal.style.display = "none";
  }
}